import ProductEditContainer from "./ProductEditContainer";

export default ProductEditContainer;
